import { useTranslation } from 'react-i18next'

import { FormikForm } from '../../Formik'
import { useEpostFormContext } from '../Epost.hooks'
import { EpostFormContent } from '../EpostFormContent'

import {
  getEpostFormDefaultInitialValues,
  getEpostFormSubmitPayload,
} from './EpostForm.utils'

function EpostForm({
  FormContainer,
  containerProps,
  getSubmitPayload = getEpostFormSubmitPayload,
  initialValues,
  onSubmit,
}) {
  const { t } = useTranslation()

  const { setInnerRef } = useEpostFormContext()

  const epostFormInitialValues =
    initialValues || getEpostFormDefaultInitialValues(t)

  function handleSubmit(values) {
    onSubmit(getSubmitPayload(values))
  }

  return (
    <FormikForm
      enableReinitialize
      Container={FormContainer}
      containerProps={containerProps}
      initialValues={epostFormInitialValues}
      innerRef={setInnerRef}
      validateOnBlur={false}
      validateOnChange={false}
      onSubmit={handleSubmit}
    >
      <EpostFormContent />
    </FormikForm>
  )
}

export default EpostForm
